import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import styled from 'styled-components'
import { FormattedMenuSectionInfo } from 'api'

import MenuItemRow from '../MenuItemRow'
import DragHandle from './DragHandle'

const SortableItemContainer = styled.div<{ isDragging?: boolean }>`
  position: relative;
  overflow: visible;
  width: 100%;
  ${({ isDragging }) => isDragging && `
    opacity: 1;
    z-index: 1000;
  `}
`

const DragHandleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 100%;
  padding-left: 12px;
  flex-shrink: 0;
`

interface SortableMenuItemProps {
  item: FormattedMenuSectionInfo
  itemIdx: number
  isSelected?: boolean
  isExpanded?: boolean
  isChildItem?: boolean
  onItemToggle?: (id: string) => void
  isPreviewOnly?: boolean
  onRowExpand?: () => void
  modifiersExist?: boolean
  setSuspendUntilItem?: any
  existingSuspendUntil?: string | null | undefined
  checkBoxContainerStyle?: React.CSSProperties
  isModifiersLoading: boolean
  menuItemStyle?: React.CSSProperties
  menuItemTextStyle?: React.CSSProperties
  setSelectedItemInModal?: (item: FormattedMenuSectionInfo) => void
  isEditor?: boolean
  onDeleteItem?: (item: FormattedMenuSectionInfo) => void
  itemPrice?: number
  onChangeItemPrice?: (itemSubsectionId: string, newPrice?: number) => void
  itemSubsectionId?: string
  isPrinterClient?: boolean
}

const SortableMenuItem: React.FC<SortableMenuItemProps> = ({
  item,
  itemIdx,
  isSelected,
  isExpanded,
  isChildItem,
  onItemToggle,
  isPreviewOnly,
  onRowExpand,
  modifiersExist,
  setSuspendUntilItem,
  existingSuspendUntil,
  checkBoxContainerStyle,
  isModifiersLoading,
  menuItemStyle = {},
  menuItemTextStyle = {},
  setSelectedItemInModal,
  isEditor,
  onDeleteItem,
  itemPrice,
  onChangeItemPrice,
  itemSubsectionId,
  isPrinterClient,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const dragHandle = isPrinterClient ? (
    <DragHandleWrapper {...attributes} {...listeners}>
      <DragHandle id={item.id} />
    </DragHandleWrapper>
  ) : null;

  return (
    <SortableItemContainer
      ref={setNodeRef}
      style={style}
      isDragging={isDragging}
    >
      <MenuItemRow
        item={item}
        itemIdx={itemIdx}
        isSelected={isSelected}
        isExpanded={isExpanded}
        isChildItem={isChildItem}
        onItemToggle={onItemToggle}
        isPreviewOnly={isPreviewOnly}
        onRowExpand={onRowExpand}
        modifiersExist={modifiersExist}
        setSuspendUntilItem={setSuspendUntilItem}
        existingSuspendUntil={existingSuspendUntil}
        checkBoxContainerStyle={checkBoxContainerStyle}
        isModifiersLoading={isModifiersLoading}
        menuItemStyle={menuItemStyle}
        menuItemTextStyle={menuItemTextStyle}
        setSelectedItemInModal={setSelectedItemInModal}
        isEditor={isEditor}
        onDeleteItem={onDeleteItem}
        itemPrice={itemPrice}
        onChangeItemPrice={onChangeItemPrice}
        itemSubsectionId={itemSubsectionId}
        dragHandle={dragHandle}
      />
    </SortableItemContainer>
  )
}

export default SortableMenuItem 